export class RegexConstants {
    static readonly EMAIL: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    static readonly NUMBER_ONLY: RegExp = /^\d+$/;
    static readonly NUMBER_DECIMAL: RegExp = /^\d+(\.\d+)?$/;
    static readonly ALPHABET_ONLY: RegExp = /^[a-zA-Z ]+$/;
    static readonly PHONE: RegExp = /^[0-9]{6,15}$/;
    static readonly PHONE_TN: RegExp = /^[0-9]{8}$/;

    // CNAM : exactement 10 chiffres
    static readonly CNAM_CODE: RegExp = /^\d{8}\s\d{2}$/;
    static readonly DOCTOR_REF: RegExp = /^\d{2}\s\d{8}\s\d{2}$/;
}